import React from 'react';
import { View, TouchableOpacity, Image } from 'react-native';
import { Text } from '@/components/common/text';
import { useChatStyles, useChatColors } from './chatStyles';
import { SVG_COMPONENTS } from '@/assets/admin';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

const CloseIcon = SVG_COMPONENTS.CANCEL_X;
const PropertyPlaceholder = RESIDENTS_SVG_COMPONENTS.PROPERTY_PLACEHOLDER;

interface ChatHeaderProps {
  title: string;
  subtitle: string;
  imageUri?: string;
  onClose: () => void;
  onContentPress?: () => void;
}

/**
 * Reusable chat header with thumbnail, title, subtitle, and close button
 */
export const ChatHeader: React.FC<ChatHeaderProps> = ({
  title,
  subtitle,
  imageUri,
  onClose,
  onContentPress,
}) => {
  const chatStyles = useChatStyles();
  const chatColors = useChatColors();
  const ContentWrapper = onContentPress ? TouchableOpacity : View;
  const contentProps = onContentPress 
    ? { onPress: onContentPress, activeOpacity: 0.7 } 
    : {};

  return (
    <View style={chatStyles.chatHeader}>
      <ContentWrapper style={chatStyles.chatHeaderContent} {...contentProps}>
        {/* Thumbnail */}
        {imageUri ? (
          <Image
            source={{ uri: imageUri }}
            style={chatStyles.chatThumbnail}
            resizeMode="cover"
          />
        ) : (
          <View style={[chatStyles.chatThumbnail, chatStyles.chatThumbnailPlaceholder]}>
            <PropertyPlaceholder width={32} height={32} />
          </View>
        )}
        
        {/* Title & Subtitle */}
        <View style={chatStyles.chatHeaderTextContainer}>
          <Text style={chatStyles.chatTitle} numberOfLines={1}>
            {title}
          </Text>
          <Text style={chatStyles.chatSubtitle}>
            {subtitle}
          </Text>
        </View>
      </ContentWrapper>
      
      {/* Close Button */}
      <TouchableOpacity
        style={{ width: 20, height: 20, alignItems: 'center', justifyContent: 'center' }}
        onPress={onClose}
        hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
      >
        <CloseIcon width={16} height={16} color={chatColors.textMuted} />
      </TouchableOpacity>
    </View>
  );
};

